export class TableImageStyle {
  border = '';
  boxShadow = '';

  static normalize(styles: Partial<TableImageStyle>): TableImageStyle {
    const pureStyles = new TableImageStyle();

    pureStyles.border = styles.border ?? pureStyles.border;
    pureStyles.boxShadow = styles.boxShadow ?? pureStyles.boxShadow;

    return pureStyles;
  }
}
